import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'TabsBody',

  mixins: [ proxy() ],

  props: {
    data: {
      type: Object,
      default: undefined
    },

    tabs: {
      type: Array,
      default: []
    }
  },

  render
}
